import InputField from "../../../components/InputField/InputField";
import Button from "../../../components/Button/Button";
import TextArea from "../../../components/TextArea/TextArea";
import { MultiSelect } from "react-multi-select-component";
import { TagsInput } from "react-tag-input-component";

const Settings = ({
  isActiveTab,
  interestOptions,
  topicOptions,
  topics,
  setTopics,
  interests,
  setInterests,
  editProfile,
  isError,
  handleChange,
  handleUploadProfile,
  handleDropdownChange,
  handleEditProfileSave,
  changePassToggler,
  password,
  errorPassword,
  handlePassChange,
  handlePassChangeConfirm,
  handlePassPressConfirm,
  handleShowChangePass,
  handleCancelChangePass,
  languages,
  setLanguages,
}) => {
  return (
    <>
      <section className={`tabWrapper ${isActiveTab && "active"}`}>
        <div className={`ContainerTabForAllTabData allMentorWrapper`}>
          <div className="Headingforallheader">
            <div className="flex-between w-100">
              <h2 className="heading-2">Edit Profile</h2>
            </div>
          </div>

          <div className="border-btm w-100"></div>

          <div className="bodyDataForallUserdata">
            <div className="AdMainsetting mt-20  overflow">
              <div className="userProfileEdit mulipleFormInputWrap">
                <h4 className="lableHeading">Avatar</h4>
                <div className="leftWrapperPrfile mb25">
                  <div className="userProfileEditTab">
                    <label className="userProfile pointer" for="bgimg">
                      <img
                        src={
                          editProfile["profileImg"]
                            ? editProfile["profileImg"]
                            : "/assets/img/user1.png"
                        }
                        alt=""
                        className="userimg"
                        onClick={handleUploadProfile}
                      />
                      <img
                        src="/assets/img/edit.png"
                        alt=""
                        className="editimg pointer"
                      />
                    </label>
                  </div>
                  {/* <p className='mt-10 text2'>File types allowed are: jpg, jpeg, png</p> */}
                </div>
              </div>
              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Full Name</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["firstName"]}
                    name={"firstName"}
                    value={editProfile["firstName"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"First Name"}
                  />
                  <InputField
                    errorMessage={isError["lastName"]}
                    name={"lastName"}
                    value={editProfile["lastName"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"Last Name"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Email </h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["email"]}
                    name={"email"}
                    value={editProfile["email"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"Input email id"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Phone Number </h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["mobileNumber"]}
                    type={"number"}
                    name={"mobileNumber"}
                    value={editProfile["mobileNumber"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"Input contact number"}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">About</h4>
                <div className="multipleFormInput flex-center">
                  <TextArea
                    notImp={true}
                    className=""
                    placeholder="You can write about your years of experience, industry or skills."
                    errorMessage={isError["about"]}
                    name={"about"}
                    value={editProfile["about"]}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Designation</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["designation"]}
                    name={"designation"}
                    value={editProfile["designation"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"Input designation"}
                  />
                </div>
              </div>
              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Current Company Name</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["company"]}
                    name={"company"}
                    value={editProfile["company"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"Input company name"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Linkedin</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["linkedin"]}
                    name={"linkedin"}
                    value={editProfile["linkedin"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"Input linkedin profile link"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Functional focus area</h4>
                <div className="multipleFormInput flex-center">
                  <MultiSelect
                    className="newWrapFull"
                    options={interestOptions}
                    value={interests}
                    onChange={setInterests}
                    labelledBy="Select your Professional Interests"
                  />
                </div>
              </div>
              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Expertise</h4>
                <div className="multipleFormInput flex-center">
                  <MultiSelect
                    className="newWrapFull"
                    options={topicOptions}
                    value={topics}
                    onChange={setTopics}
                    labelledBy="Select your topic of mentoring"
                  />
                </div>
              </div>
              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Years of Experience</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    errorMessage={isError["yrsOfExp"]}
                    type={"number"}
                    name={"yrsOfExp"}
                    value={editProfile["yrsOfExp"]}
                    onChange={handleChange}
                    notImp={true}
                    placeholder={"8"}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Fluent In</h4>
                <div className="multipleFormInput flex-center">
                  <TagsInput
                    value={languages}
                    onChange={setLanguages}
                    placeHolder="Enter languages you are fluent in"
                  />
                </div>
              </div>

              <div className="border-btm w-100"></div>
              <div className="FooterAddmentors flex flexend">
                <Button
                  name={"Discard"}
                  className={"buttontext GreyFillButton"}
                />
                <Button
                  name={"Save Changes"}
                  className="active buttontext BlueFillButton"
                  onClick={handleEditProfileSave}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`ContainerTabForAllTabData mt-30 tabWrapper ${
            changePassToggler === 1 && "showItpass "
          }`}
        >
          <div className="Headingforallheader">
            <div className="w-100">
              <h2 className="heading-2">Change Password</h2>
            </div>
          </div>

          <div className="border-btm  w-100"> </div>

          <div className="bodyDataForallUserdata">
            <div className="Password flex-between mt-30">
              <h4 className="Passwordtext">
                Password
                <span className="text-grey6">*********</span>
              </h4>
              <Button
                className={"BlueFillButton buttontext"}
                name={"Reset Password"}
                onClick={handleShowChangePass}
              />
            </div>
          </div>
        </div>

        <div
          className={`ContainerTabForAllTabData tabWrapper mt-30 ${
            changePassToggler === 2 && "showItpass "
          }`}
        >
          <div className="Headingforallheader">
            <div className="w-100">
              <h2 className="heading-2">Change Password</h2>
            </div>
          </div>

          <div className="border-btm  w-100"> </div>

          <div className="bodyDataForallUserdata">
            <div className="flex-start AdChangePassWrap">
              <div className="mulipleFormInputWrap">
                <h4 className="lableHeading mb-10">Current Password</h4>
                <div className="w-100">
                  <div className="multipleFormInput flex-center">
                    <InputField
                      type={"password"}
                      notImp={true}
                      name={"password"}
                      value={password["password"]}
                      onChange={handlePassChange}
                      errorMessage={errorPassword["password"]}
                      placeholder={"******"}
                      onKeyDown={handlePassPressConfirm}
                    />
                  </div>
                  <p className="text2 mt-12">
                    Password must be at least 8 character and contain symbols
                  </p>
                </div>
              </div>
              <div className="mulipleFormInputWrap">
                <h4 className="lableHeading mb-10">New Password</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    type={"password"}
                    notImp={true}
                    name={"newPassword"}
                    value={password["newPassword"]}
                    onChange={handlePassChange}
                    errorMessage={errorPassword["newPassword"]}
                    placeholder={"******"}
                    onKeyDown={handlePassPressConfirm}
                  />
                </div>
              </div>
              <div className="mulipleFormInputWrap">
                <h4 className="lableHeading mb-10">Confirm Password</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    type={"password"}
                    notImp={true}
                    name={"confirmPassword"}
                    value={password["confirmPassword"]}
                    onChange={handlePassChange}
                    errorMessage={errorPassword["confirmPassword"]}
                    placeholder={"******"}
                    onKeyDown={handlePassPressConfirm}
                  />
                </div>
              </div>
            </div>
            <div className="flex mt-40 gap-20">
              <Button
                className={"GreyFillButton  buttontext"}
                name={"Discard"}
                onClick={handleCancelChangePass}
              />
              <Button
                className={"BlueFillButton buttontext"}
                name={"Update Password"}
                onClick={handlePassChangeConfirm}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Settings;
